const timeTypes = [
  // {
  //   value: "sec",
  //   label: "秒级"
  // },
  {
    value: "min",
    label: "分钟"
  },
  {
    value: "hour",
    label: "时均"
  },
  {
    value: "day",
    label: "日均"
  },
  {
    value: "week",
    label: "周均"
  },
  {
    value: "month",
    label: "月均"
  }
];

//value_III: III类水质标准值, value_IV: IV类水质标准值, value_V: V类水质标准值
const waterValueV = [
  {
    value: "cod",
    value_I: 15,
    value_II: 15,
    value_III: 20,
    value_IV: 30,
    value_V: 40
  },
  {
    value: "ammonia_nitrogen",
    value_I: 0.15,
    value_II: 0.5,
    value_III: 1,
    value_IV: 1.5,
    value_V: 2
  },
  {
    value: "dissolved_oxygen",
    value_I: 7.5,
    value_II: 6,
    value_III: 5,
    value_IV: 3,
    value_V: 2
  },
  { value: "ph", value_V: [6, 9] }
];

const waterNormOptions = [
  {
    label: "I类",
    value: "I"
  },
  {
    label: "II类",
    value: "II"
  },
  {
    label: "III类",
    value: "III"
  },
  {
    label: "IV类",
    value: "IV"
  },
  {
    label: "V类",
    value: "V"
  }
];

const taskStatusOptions = [
  {
    label: "进行中",
    value: 1
  },
  {
    label: "已完成",
    value: 0
  },
  {
    label: "异常",
    value: 4
  }
];

export { timeTypes, waterValueV, waterNormOptions, taskStatusOptions };
